module.exports = __webpack_public_path__ + "img/op_img-header.b0df0a6.png";